import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "table-wrapper" }
const _hoisted_2 = { class: "custom-table" }
const _hoisted_3 = {
  key: 0,
  style: {"height":"100%"},
  class: "text-center"
}
const _hoisted_4 = ["colspan"]
const _hoisted_5 = { class: "text-grey" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableListHead = _resolveComponent("TableListHead")!
  const _component_TableListCriterion = _resolveComponent("TableListCriterion")!
  const _component_TableListAim = _resolveComponent("TableListAim")!
  const _component_TableListAlternative = _resolveComponent("TableListAlternative")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_TableListFoot = _resolveComponent("TableListFoot")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pa-0 fill-height d-flex flex-column"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          _createElementVNode("thead", null, [
            _createVNode(_component_TableListHead)
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.c_criterionsIds, (criterionId) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: `criterion-block-${criterionId}`
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAimsBy('criterion', criterionId), (aim, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: `aim-${criterionId}-${aim.id}`
                  }, [
                    (index === 0)
                      ? _withDirectives((_openBlock(), _createBlock(_component_TableListCriterion, {
                          key: 0,
                          aim: aim,
                          criterionId: criterionId
                        }, null, 8, ["aim", "criterionId"])), [
                          [_vShow, _ctx.getFilteredCriterions.includes(criterionId)]
                        ])
                      : _createCommentVNode("", true),
                    _withDirectives(_createVNode(_component_TableListAim, { aim: aim }, null, 8, ["aim"]), [
                      [_vShow, _ctx.getFilteredAims.includes(aim.id)]
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alternativesIds, (alternativeId) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: `alternative-block-${alternativeId}`
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subOptionsIds, (subOptionId) => {
                          return _withDirectives((_openBlock(), _createBlock(_component_TableListAlternative, {
                            key: `alternative-${alternativeId}-${subOptionId}`,
                            aim: aim,
                            criterionId: criterionId,
                            alternativeId: alternativeId,
                            subOptionId: subOptionId,
                            alternativesIds: _ctx.alternativesIds,
                            subOptionsIds: _ctx.subOptionsIds
                          }, null, 8, ["aim", "criterionId", "alternativeId", "subOptionId", "alternativesIds", "subOptionsIds"])), [
                            [_vShow, _ctx.getFilteredAims.includes(aim.id)]
                          ])
                        }), 128))
                      ], 64))
                    }), 128))
                  ]))
                }), 128))
              ], 64))
            }), 128)),
            (!_ctx.getFilteredItems.length)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
                  _createElementVNode("td", {
                    class: "pt-10",
                    colspan: 5 + _ctx.alternativesIds.length
                  }, [
                    _createElementVNode("b", _hoisted_5, [
                      _cache[1] || (_cache[1] = _createTextVNode(" No results. ")),
                      _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                      _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                      _createVNode(_component_v_btn, {
                        size: "small",
                        color: "secondary",
                        onClick: _ctx.clearAppFilters
                      }, {
                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                          _createTextVNode("clear filters")
                        ])),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ], 8, _hoisted_4)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("tfoot", null, [
            _createVNode(_component_TableListFoot)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}